/* istanbul ignore file */
import axios from 'axios'
import { getVarValue } from '../../common/utils/Sparky'
import { getTsgToken, getFrameworkServiceUrl } from '@sparky/framework'
import { FF_USE_LOCAL_INSTANCE_SERVICE } from '../../common/utils/FeatureFlags'

const includeClaims = getVarValue(FF_USE_LOCAL_INSTANCE_SERVICE, false)

/**
 * Created by vsuthar on 9/28/21
 * File: InstanceService
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */
const INSTANCE_STORE_URL_KEY = 'instance_store'
const InstanceServiceAPI = axios.create({
  baseURL: getFrameworkServiceUrl(INSTANCE_STORE_URL_KEY) || getVarValue(INSTANCE_STORE_URL_KEY),
  timeout: 300 * 1000,
})

InstanceServiceAPI.interceptors.request.use(async config => {
  const token = await getTsgToken(config?.tsg_id)
  config.headers = { ...config.headers, 'Authorization': `Bearer ${token}` }
  if (includeClaims) {
    config.headers.claims = token.split('.')[1]
  }
  return config
}, error => {
  return Promise.reject(error)
})

InstanceServiceAPI.interceptors.response.use((response) => response, (error) => {
  throw new Error(error.response?.data?.message || error.response?.data?.msg || error.message)
})

const InstanceService = {
  listInstance: {
    get: (tsg_id, params) => InstanceServiceAPI.get('/instances', { tsg_id, params })
  },
  getInstances: {
    get: async (tsgIds) => {
      if (tsgIds && Array.isArray(tsgIds) && tsgIds.length) {
        // const axiosInstanceReq = tsgIds.map(tsg_id => InstanceServiceAPI.get('/instances', { tsg_id, params: { tsg_id } }))
        // return await axios.all(axiosInstanceReq)
        const instances = []
        for (const tsg_id of tsgIds) {
          await InstanceServiceAPI.get('/instances', { tsg_id, params: { tsg_id: tsg_id } }).then(({ data }) => {
            instances.push(...data)
          }).catch(e => {
            // do nothing
          })
        }
        return instances
      }
    }
  }
}

export default InstanceService
